/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/v_magnitude.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Calculates the magnitude of a dense_vector.',
  examples: [
    ' from colors\n | eval magnitude = v_magnitude(rgb_vector)\n | sort magnitude desc, color asc',
  ],
  params: {
    input: 'dense_vector for which to compute the magnitude',
  },
};

export default docs;
